import { render, staticRenderFns } from "./upload-file-material.component.vue?vue&type=template&id=a0ec1dda&scoped=true&"
import script from "./upload-file-material.component.ts?vue&type=script&lang=ts&"
export * from "./upload-file-material.component.ts?vue&type=script&lang=ts&"
import style0 from "./upload-file-material.component.scss?vue&type=style&index=0&id=a0ec1dda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ec1dda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
